<template>
  <v-card>
    <v-tabs dense v-model="activeTab">
      <v-tab>
        <v-icon left>view_stream</v-icon>
        Series
      </v-tab>
      <v-tab>
        <v-icon left>view_list</v-icon>
        Subseries
      </v-tab>

      <v-tab-item>
        <v-card class="elevation-0">
          <classeries v-if="activeTab == 0"/>
        </v-card>
      </v-tab-item>

      <v-tab-item >
        <v-card class="elevation-0">
          <classubseries v-if="activeTab == 1"/>
        </v-card>
      </v-tab-item>

    </v-tabs>
  </v-card>
</template>

<script>
  import mixinsSerie from '@/mixins/mixinsSerie.js'
  import {mapGetters} from 'vuex'
  import classeries from '@/views/Clasificaciones/clasSeries.vue'
  import classubseries from '@/views/Clasificaciones/clasSubseries.vue'
  export default {
  	components:{
  		classeries,
  		classubseries
  	},


    data () {
      return {
        activeTab: '',
      }
    },

    watch:{
      activeTab(){
        console.log(this.activeTab)
      }
    },

    cretaed(){
    	this.$router.push({name:'classeries'}).catch(error=>{console.log(error)})
    }
  }

</script>